import type { BaseBlock } from "../../DataModel.types";
import { getBlockPathInfo, getParentArray } from "../../Helpers/blockPath";
import type { ListPolicies } from "../types";

const getCanDeleteSelectedBlock = ({
  selectedBlockPath,
  getBlocks,
  listPolicies,
}: {
  selectedBlockPath: string | null;
  getBlocks: () => BaseBlock;
  listPolicies: ListPolicies | undefined;
}) => {
  if (!selectedBlockPath) {
    return false;
  }

  const { currentIndex, relativeParentPath } =
    getBlockPathInfo(selectedBlockPath);
  if (currentIndex === -1) {
    return false;
  }

  const parentArray = getParentArray(getBlocks(), relativeParentPath);
  if (!parentArray) {
    return false;
  }

  const policy = listPolicies?.[relativeParentPath];
  if (!policy || !policy.isDeletable) {
    return true;
  }

  return policy.isDeletable(parentArray[currentIndex]);
};

export default getCanDeleteSelectedBlock;
